// ===== COLOR SELECTION =====
var yiyoSelectedColor = null;
var yiyoSelectedSize = null;
var yiyoAddonTotal = 0;
var yiyoBasePrice = window.YIYO.basePrice;
var yiyoActiveAddons = {};
var yiyoProductTags = window.YIYO.tags;

// All variants as JSON for selection logic
var yiyoVariants = window.YIYO.variants;

function yiyoSelectColor(el) {
  document.querySelectorAll('.yiyo-color-item').forEach(function(i) {
    i.classList.remove('active');
    i.querySelector('.yiyo-swatch-wrap').classList.remove('active-check');
  });
  el.classList.add('active');
  el.querySelector('.yiyo-swatch-wrap').classList.add('active-check');
  yiyoSelectedColor = el.dataset.color;
  // Update selected bar
  var selName = document.getElementById('yiyo-sel-color-name');
  if (selName) selName.textContent = 'Selected: ' + yiyoSelectedColor;
  var previewBg = document.getElementById('yiyo-sel-preview-bg');
  if (previewBg) previewBg.style.background = yiyoGetSwatchBg(yiyoSelectedColor);
  yiyoUpdateVariant();
}

// ===== SIZE SELECTION =====
function yiyoSelectSize(el) {
  document.querySelectorAll('.yiyo-size-btn').forEach(function(b) { b.classList.remove('active'); });
  el.classList.add('active');
  yiyoSelectedSize = el.dataset.size;
  // Update spec bar
  var specSize = document.getElementById('yiyo-spec-size');
  if (specSize) specSize.textContent = yiyoSelectedSize;
  yiyoUpdateVariant();
}

// ===== VARIANT MATCHING =====
function yiyoUpdateVariant() {
  var colorIdx = window.YIYO.colorIdx;
  var sizeIdx = window.YIYO.sizeIdx;
  var matched = yiyoVariants.find(function(v) {
    var colorMatch = colorIdx < 0 || !yiyoSelectedColor || v['option' + (colorIdx+1)] === yiyoSelectedColor;
    var sizeMatch  = sizeIdx < 0  || !yiyoSelectedSize  || v['option' + (sizeIdx+1)]  === yiyoSelectedSize;
    return colorMatch && sizeMatch && v.available;
  });
  if (!matched) {
    matched = yiyoVariants.find(function(v) {
      var colorMatch = colorIdx < 0 || !yiyoSelectedColor || v['option' + (colorIdx+1)] === yiyoSelectedColor;
      var sizeMatch  = sizeIdx < 0  || !yiyoSelectedSize  || v['option' + (sizeIdx+1)]  === yiyoSelectedSize;
      return colorMatch && sizeMatch;
    });
  }
  if (matched) {
    document.getElementById('yiyo-variant-id').value = matched.id;
    yiyoBasePrice = matched.price;
    yiyoRefreshPrice();
    var cartBtn = document.getElementById('yiyo-add-cart');
    if (cartBtn) cartBtn.disabled = !matched.available;
  }
}

// ===== PRICE REFRESH =====
var yiyoMoneyFormat = window.YIYO.moneyFormat;
function yiyoFormatMoney(cents) {
  return yiyoMoneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function(match, key) {
    var val = (cents / 100);
    switch(key) {
      case 'amount': return val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      case 'amount_no_decimals': return Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      case 'amount_with_comma_separator': return val.toFixed(2).replace(/\./, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      case 'amount_with_space_separator': return val.toFixed(2).replace(/\./, ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      default: return val.toFixed(2);
    }
  });
}
function yiyoRefreshPrice() {
  var total = yiyoBasePrice + yiyoAddonTotal;
  var formatted = yiyoFormatMoney(total);
  var el = document.getElementById('yiyo-cart-price');
  if (el) el.innerHTML = formatted;
  var sticky = document.getElementById('yiyo-sticky-price');
  if (sticky) sticky.innerHTML = formatted;
  var priceEl = document.getElementById('yiyo-price');
  if (priceEl) priceEl.innerHTML = formatted;
}

// ===== ADD-ON TOGGLE (Plan B: Independent Products) =====
function yiyoToggleAddon(headEl) {
  var card = headEl.closest('.yiyo-addon');
  if (!card) return;
  var isSelected = card.classList.contains('yiyo-selected');
  var body = card.querySelector('.yiyo-addon-body');

  if (isSelected) {
    card.classList.remove('yiyo-selected');
    if (body) { body.style.maxHeight = '0'; body.style.overflow = 'hidden'; }
  } else {
    card.classList.add('yiyo-selected');
    if (body) { body.style.maxHeight = (body.scrollHeight || 300) + 'px'; body.style.overflow = 'visible'; }
  }

  // Recalculate addon display total
  yiyoAddonTotal = 0;
  document.querySelectorAll('.yiyo-addon.yiyo-selected').forEach(function(c) {
    var p = parseFloat(c.dataset.addonPrice || 0);
    yiyoAddonTotal += p * 100;
  });
  yiyoRefreshPrice();
}

// ===== ADDON CLICK DELEGATION (EComposer-proof) =====
document.addEventListener('click', function(e) {
  var head = e.target.closest ? e.target.closest('.yiyo-addon-head') : null;
  if (!head) return;
  e.stopImmediatePropagation();
  e.preventDefault();
  yiyoToggleAddon(head);
}, true);

// ===== ADD-ON VISIBILITY FILTERING =====
// Rules:
//   1. Products WITHOUT "base:xxx" tag → hide ALL add-ons (accessories, women's pieces, etc.)
//   2. Products WITH "base:xxx" tag → show only compatible add-ons
//   3. Products with "no-addon" tag → force hide ALL add-ons
//
// Tag examples:
//   base:lace     → Full lace base (Haircut OK, Bleach OK, Cut base NO)
//   base:mono     → Mono top (Haircut OK, Bleach OK, Cut base OK)
//   base:skin     → Thin skin/PU (Haircut OK, Bleach NO, Cut base OK)
//   base:poly     → Poly base (Haircut OK, Bleach NO, Cut base OK)
//   no-addon      → Force hide all add-ons for this product
//
(function() {
  var productTags = yiyoProductTags;
  var baseType = '';
  var forceNoAddon = false;

  productTags.forEach(function(tag) {
    var lower = tag.toLowerCase().trim();
    if (lower.indexOf('base:') === 0) {
      baseType = lower.replace('base:', '').trim();
    }
    if (lower === 'no-addon' || lower === 'no-addons' || lower === 'noaddon') {
      forceNoAddon = true;
    }
  });

  var addonSection = document.getElementById('yiyo-addon-section');
  if (!addonSection) return;

  // No base type tag OR force no-addon → hide entire add-on section
  if (!baseType || forceNoAddon) {
    addonSection.style.display = 'none';
    return;
  }

  // Has base type → show section, but filter individual add-ons by compatibility
  document.querySelectorAll('.yiyo-addon[data-base-types]').forEach(function(card) {
    var types = card.dataset.baseTypes.toLowerCase();
    if (types === 'all') return; // show for all base types
    var allowed = types.split(',').map(function(t) { return t.trim(); });
    if (allowed.indexOf(baseType) === -1) {
      card.classList.add('yiyo-addon-hidden');
    }
  });

  // If ALL add-ons are hidden after filtering, hide the entire section
  var visibleAddons = addonSection.querySelectorAll('.yiyo-addon:not(.yiyo-addon-hidden)');
  if (visibleAddons.length === 0) {
    addonSection.style.display = 'none';
  }
})();

// ===== HAIRSTYLE SELECTION =====
// ===== HAIRSTYLE / COLOR OVERLAY GALLERY =====
// These are shared globals — color picker (yh-color-picker.liquid) also writes to them via window.*
window._yiyoHsImages = [];
window._yiyoHsIndex = 0;
window._yiyoHairstyleGalleryActive = false;
window._yiyoHsLabels = null;

function yiyoSelectHairstyle(el) {
  // Deselect all
  document.querySelectorAll('.yiyo-hs-item').forEach(function(item) {
    item.classList.remove('yiyo-hs-active');
  });
  // Select clicked
  el.classList.add('yiyo-hs-active');
  var style = el.dataset.style;
  var propEl = document.getElementById('yiyo-hairstyle-prop');
  if (propEl) propEl.value = style;

  // Show/hide upload area for "Others"
  var uploadArea = document.getElementById('yiyo-hs-upload-area');
  if (uploadArea) {
    uploadArea.style.display = (style === 'Others') ? 'block' : 'none';
  }

  // --- Hairstyle Overlay Gallery ---
  var galleryStr = (el.dataset.gallery || '').trim();
  if (!galleryStr) {
    yiyoHsOverlayClose();
    return;
  }

  var urls = galleryStr.split(',').map(function(u) { return u.trim(); }).filter(Boolean);
  if (urls.length === 0) {
    yiyoHsOverlayClose();
    return;
  }

  _yiyoHsImages = urls;
  _yiyoHsIndex = 0;
  _yiyoHairstyleGalleryActive = true;
  window._yiyoHsLabels = null;

  var overlay = document.getElementById('yiyo-hs-overlay');
  var overlayImg = document.getElementById('yiyo-hs-overlay-img');
  var label = document.getElementById('yiyo-hs-overlay-label');
  var counter = document.getElementById('yiyo-hs-overlay-counter');

  if (overlay) overlay.style.display = 'flex';
  if (overlayImg) overlayImg.src = urls[0];
  if (label) label.textContent = style;
  if (counter) counter.textContent = '1 / ' + urls.length;

  // Deselect product thumbnails
  document.querySelectorAll('.yiyo-thumb').forEach(function(t) { t.classList.remove('active'); });
}

function yiyoHsNav(dir) {
  if (_yiyoHsImages.length === 0) return;
  _yiyoHsIndex += dir;
  if (_yiyoHsIndex < 0) _yiyoHsIndex = _yiyoHsImages.length - 1;
  if (_yiyoHsIndex >= _yiyoHsImages.length) _yiyoHsIndex = 0;

  var overlayImg = document.getElementById('yiyo-hs-overlay-img');
  var counter = document.getElementById('yiyo-hs-overlay-counter');
  var label = document.getElementById('yiyo-hs-overlay-label');
  if (overlayImg) overlayImg.src = _yiyoHsImages[_yiyoHsIndex];
  if (counter) counter.textContent = (_yiyoHsIndex + 1) + ' / ' + _yiyoHsImages.length;
  // Update label if we have per-image labels (e.g. color codes)
  if (label && window._yiyoHsLabels && window._yiyoHsLabels[_yiyoHsIndex]) {
    label.textContent = window._yiyoHsLabels[_yiyoHsIndex];
  }
}

function yiyoHsOverlayClose() {
  var overlay = document.getElementById('yiyo-hs-overlay');
  if (overlay) overlay.style.display = 'none';
  _yiyoHsImages = [];
  _yiyoHsIndex = 0;
  _yiyoHairstyleGalleryActive = false;
  // Re-activate first product thumbnail
  var firstThumb = document.querySelector('.yiyo-thumb');
  if (firstThumb) firstThumb.classList.add('active');
}

// ===== HAIRSTYLE FILTERING BY BASE TYPE =====
(function() {
  var productTags = yiyoProductTags;
  var baseType = '';
  productTags.forEach(function(tag) {
    var lower = tag.toLowerCase().trim();
    if (lower.indexOf('base:') === 0) {
      baseType = lower.replace('base:', '').trim();
    }
  });

  if (baseType) {
    document.querySelectorAll('.yiyo-hs-item[data-base-types]').forEach(function(item) {
      var types = item.dataset.baseTypes.toLowerCase();
      if (types === 'all') return;
      var allowed = types.split(',').map(function(t) { return t.trim(); });
      if (allowed.indexOf(baseType) === -1) {
        item.classList.add('yiyo-hs-hidden');
      }
    });
  }
})();

// ===== PHOTO UPLOAD =====
(function() {
  var uploadBox = document.getElementById('yiyo-hs-upload-box');
  var fileInput = document.getElementById('yiyo-hs-file');
  var placeholder = document.getElementById('yiyo-hs-upload-placeholder');
  var preview = document.getElementById('yiyo-hs-upload-preview');
  var previewImg = document.getElementById('yiyo-hs-preview-img');
  var uploadProp = document.getElementById('yiyo-hs-upload-prop');

  if (!uploadBox || !fileInput) return;

  uploadBox.addEventListener('click', function() {
    fileInput.click();
  });

  // Drag & drop
  uploadBox.addEventListener('dragover', function(e) {
    e.preventDefault();
    uploadBox.style.borderColor = '#C87D4F';
  });
  uploadBox.addEventListener('dragleave', function() {
    uploadBox.style.borderColor = '#d1d5db';
  });
  uploadBox.addEventListener('drop', function(e) {
    e.preventDefault();
    uploadBox.style.borderColor = '#d1d5db';
    if (e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  });

  fileInput.addEventListener('change', function() {
    if (fileInput.files.length > 0) {
      handleFile(fileInput.files[0]);
    }
  });

  function handleFile(file) {
    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file (JPG, PNG).');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('File size must be under 5MB.');
      return;
    }

    var reader = new FileReader();
    reader.onload = function(e) {
      if (previewImg) previewImg.src = e.target.result;
      if (placeholder) placeholder.style.display = 'none';
      if (preview) preview.style.display = 'inline-block';
      // Store filename as property (actual image sent via email)
      if (uploadProp) uploadProp.value = 'Uploaded: ' + file.name + ' (please email to support@yiyohair.com)';
    };
    reader.readAsDataURL(file);
  }
})();

window.yiyoRemoveUpload = function() {
  var placeholder = document.getElementById('yiyo-hs-upload-placeholder');
  var preview = document.getElementById('yiyo-hs-upload-preview');
  var fileInput = document.getElementById('yiyo-hs-file');
  var uploadProp = document.getElementById('yiyo-hs-upload-prop');
  if (placeholder) placeholder.style.display = 'flex';
  if (preview) preview.style.display = 'none';
  if (fileInput) fileInput.value = '';
  if (uploadProp) uploadProp.value = '';
};

// ===== GALLERY =====
function yiyoSelectImage(src, thumbEl) {
  // Close hairstyle overlay when clicking a product thumbnail
  if (_yiyoHairstyleGalleryActive) {
    var overlay = document.getElementById('yiyo-hs-overlay');
    if (overlay) overlay.style.display = 'none';
    _yiyoHairstyleGalleryActive = false;
  }
  var mainImg = document.getElementById('yiyo-main-img-el');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.yiyo-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (thumbEl) thumbEl.classList.add('active');
}
function yiyoGalleryTab(btn, tab) {
  document.querySelectorAll('.yiyo-gallery-tab').forEach(function(t) { t.classList.remove('active'); });
  btn.classList.add('active');
  document.querySelectorAll('.yiyo-gallery-panel').forEach(function(p) { p.classList.remove('active'); });
  var panel = document.querySelector('.yiyo-gallery-panel[data-panel="' + tab + '"]');
  if (panel) panel.classList.add('active');
  /* Show main image area for gallery, hide for before-after when clicked */
  var mainImg = document.getElementById('yiyo-main-img');
  if (mainImg) mainImg.style.display = (tab === 'video') ? 'none' : '';
  // Close hairstyle overlay when switching tabs
  if (_yiyoHairstyleGalleryActive) {
    var overlay = document.getElementById('yiyo-hs-overlay');
    if (overlay) overlay.style.display = 'none';
    _yiyoHairstyleGalleryActive = false;
  }
}

// ===== COLLAPSIBLE =====
function yiyoToggle(header) {
  header.closest('.yiyo-collapsible').classList.toggle('open');
}

// ===== STICKY BAR =====
// Sticky bar is always visible (position: fixed), no scroll toggle needed.

// ===== CART API SUBMISSION (Plan B: Multi-item Add) =====
var yiyoCartSubmitting = false;

function yiyoAddToCart(e) {
  if (e) e.preventDefault();
  if (yiyoCartSubmitting) return;

  var hasAddons = document.querySelectorAll('.yiyo-addon.yiyo-selected').length > 0;

  // If add-ons selected, show Final Sale confirmation first
  if (hasAddons && !yiyoCartSubmitting) {
    var modal = document.getElementById('yiyo-finalsale-modal');
    if (modal && !modal.dataset.confirmed) {
      modal.classList.add('active');
      return;
    }
  }

  yiyoCartSubmitting = true;
  var cartBtn = document.getElementById('yiyo-add-cart');
  if (cartBtn) {
    cartBtn.disabled = true;
    cartBtn.textContent = 'ADDING...';
  }

  var items = [];

  // 1. Main product
  var mainVariantId = document.getElementById('yiyo-variant-id').value;
  var mainProps = {};
  if (yiyoSelectedColor) mainProps['Hair Color'] = yiyoSelectedColor;
  if (yiyoSelectedSize) mainProps['Base Size'] = yiyoSelectedSize;

  // Check if any addons are selected — mark main product too
  if (hasAddons) {
    var addonNames = [];
    document.querySelectorAll('.yiyo-addon.yiyo-selected').forEach(function(c) {
      addonNames.push(c.dataset.addonName);
    });
    mainProps['Add-on Services'] = addonNames.join(', ');
  }

  items.push({
    id: parseInt(mainVariantId),
    quantity: 1,
    properties: mainProps
  });

  // 2. Add-on products (independent items)
  document.querySelectorAll('.yiyo-addon.yiyo-selected').forEach(function(card) {
    var addonVariantId = card.dataset.variantId;
    if (!addonVariantId) {
      console.warn('YIYO: Add-on "' + card.dataset.addonName + '" has no variant ID configured. Skipping.');
      return;
    }

    var props = {};
    // Collect form fields within this addon
    card.querySelectorAll('[data-prop]').forEach(function(inp) {
      var val = (inp.value || '').trim();
      if (val) props[inp.dataset.prop] = val;
    });

    // Link back to main product for order fulfillment
    props['For Product'] = window.YIYO.productTitle;
    if (yiyoSelectedColor) props['Product Color'] = yiyoSelectedColor;
    if (yiyoSelectedSize) props['Product Size'] = yiyoSelectedSize;

    items.push({
      id: parseInt(addonVariantId),
      quantity: 1,
      properties: props
    });
  });

  // 3. Submit to Cart API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Cart API error: ' + res.status);
    return res.json();
  })
  .then(function(data) {
    // Success — redirect to cart
    window.location.href = '/cart';
  })
  .catch(function(err) {
    console.error('YIYO Cart Error:', err);
    alert('Failed to add to cart. Please try again.');
    yiyoCartSubmitting = false;
    if (cartBtn) {
      cartBtn.disabled = false;
      cartBtn.innerHTML = 'ADD TO CART — <span id="yiyo-cart-price">' + yiyoRefreshPrice(true) + '</span>';
    }
  });
}

// Hijack form submit — use Cart API instead of default form POST
var yiyoForm = document.getElementById('yiyo-product-form');
if (yiyoForm) {
  yiyoForm.addEventListener('submit', yiyoAddToCart, true);
}

// Also bind the sticky bar cart button
document.addEventListener('click', function(e) {
  var stickyBtn = e.target.closest('.yiyo-sticky-bar .yiyo-btn-cart');
  if (stickyBtn) {
    e.preventDefault();
    e.stopPropagation();
    yiyoAddToCart(e);
  }
}, true);

// Final Sale modal handlers
document.addEventListener('click', function(e) {
  if (e.target.closest('.yiyo-finalsale-btn-cancel')) {
    var modal = document.getElementById('yiyo-finalsale-modal');
    if (modal) modal.classList.remove('active');
  }
  if (e.target.closest('.yiyo-finalsale-btn-confirm')) {
    var modal = document.getElementById('yiyo-finalsale-modal');
    if (modal) {
      modal.dataset.confirmed = '1';
      modal.classList.remove('active');
      yiyoAddToCart(null);
      // Reset confirmation for next time
      setTimeout(function() { delete modal.dataset.confirmed; }, 1000);
    }
  }
});

// Update yiyoRefreshPrice to optionally return formatted string
var _origRefreshPrice = yiyoRefreshPrice;
yiyoRefreshPrice = function(returnStr) {
  var total = yiyoBasePrice + yiyoAddonTotal;
  var formatted = yiyoFormatMoney(total);
  var el = document.getElementById('yiyo-cart-price');
  if (el) el.innerHTML = formatted;
  var sticky = document.getElementById('yiyo-sticky-price');
  if (sticky) sticky.innerHTML = formatted;
  var priceEl = document.getElementById('yiyo-price');
  if (priceEl) priceEl.innerHTML = formatted;
  if (returnStr) return formatted;
};

// Init
document.addEventListener('DOMContentLoaded', function() {
  var firstColor = document.querySelector('.yiyo-color-item');
  if (firstColor) yiyoSelectedColor = firstColor.dataset.color;
  var firstSize = document.querySelector('.yiyo-size-btn');
  if (firstSize) yiyoSelectedSize = firstSize.dataset.size;
});
